import script from "./ContactForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactForm.vue?vue&type=script&setup=true&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=4b7f6e74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7f6e74"]])

export default __exports__